import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur länge gäller ett godkänt kunskapsprov?";
const SHORT_ANSWER = "Tills vidare så länge alkohollagen inte ändras väsentligt. Vid större lagändringar (som 2026) kan kommuner kräva nytt prov.";

export const Route = createFileRoute("/fraga/hur-lange-galler-godkant-prov")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur länge gäller ett godkänt kunskapsprov" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Det finns ingen formell utgångstid i FoHMFS 2014:7, men vid ny ansökan flera år efter godkännandet kan kommunen göra en bedömning, särskilt om lagen har ändrats."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – giltighetstid" }}
      related={[{"to": "/fraga/behover-jag-gora-om-provet-vid-utokning", "label": "Behöver jag göra om provet om jag utökar tillståndet?"}, {"to": "/fraga/hur-bra-ar-folkhalsomyndighetens-databas", "label": "Hur ser kunskapsprovets frågedatabas ut?"}, {"to": "/fraga/galler-provet-i-alla-kommuner", "label": "Gäller godkänt kunskapsprov i alla kommuner?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur länge gäller ett godkänt kunskapsprov?" },
      { name: "description", content: "Tills vidare så länge alkohollagen inte ändras väsentligt. Vid större lagändringar (som 2026) kan kommuner kräva nytt prov." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-lange-galler-godkant-prov" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-lange-galler-godkant-prov" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-lange-galler-godkant-prov",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur länge gäller ett godkänt kunskapsprov", url: "https://alkoholprovet.se/fraga/hur-lange-galler-godkant-prov" },
      ]),
    ],
  }),
});
